export const EVENT_EDIT_ROUTE = '/trips/:tripId/itinerary/events/:eventId/edit'

/** The edit-event flow for one of a trip's events. */
export const editEventPath = (tripId: string | number, eventId: number): string =>
	`/trips/${tripId}/itinerary/events/${eventId}/edit`

/** Parses the route's `:eventId`, or null when malformed. */
export const eventIdFromParam = (param: string | undefined): number | null =>
	param !== undefined && /^\d+$/.test(param) ? Number(param) : null
